import { defineStore } from 'pinia'

import type { UpsellFlowStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useUpsellFlowStore = defineStore('upsell-flow', {
  state: (): UpsellFlowStore => ({
    step: 'landing',
    offerUnavailable: false,
  }),
  actions,
  getters,
})
